// import React, { useContext } from 'react'
// import scrollTop from '../helpers/scrollTop'
// import displayINRCurrency from '../helpers/displayCurrency'
// import Context from '../context'
// import addToCart from '../helpers/addToCart'
// import { Link } from 'react-router-dom'
// import { useDispatch } from 'react-redux'
// import { motion } from "framer-motion"

// const VerticalCard = ({ loading, data = [] }) => {

//     const loadingList = new Array(8).fill(null)
//     const { fetchUserAddToCart } = useContext(Context)
//     const dispatch = useDispatch()

//     const handleAddToCart = async (e, id) => {
//         e.preventDefault()
//         e.stopPropagation()

//         await addToCart(id, dispatch)

//         if (fetchUserAddToCart) {
//             fetchUserAddToCart()
//         }
//     }

//     return (
//         <div className='grid grid-cols-1 gap-6'>

//             {loading ? (
//                 loadingList.map((_, index) => (
//                     <div key={index} className='bg-white rounded-xl shadow p-4 animate-pulse'>
//                         <div className='h-40 bg-gray-200 rounded'></div>
//                         <div className='h-4 bg-gray-200 mt-4 rounded'></div>
//                         <div className='h-4 bg-gray-200 mt-2 rounded'></div>
//                     </div>
//                 ))
//             ) : (
//                 data.map((product, i) => {

//                     // 🔥 FIXED PRICE LOGIC
//                     const price = product?.variants?.[0]?.price || 0

//                     return (
//                         <motion.div
//                             key={product._id}
//                             initial={{ opacity: 0, y: 40 }}
//                             animate={{ opacity: 1, y: 0 }}
//                             transition={{ delay: i * 0.05 }}
//                             whileHover={{ y: -6 }}
//                             className='bg-white rounded-xl shadow hover:shadow-xl transition overflow-hidden group'
//                         >

//                             {/* IMAGE */}
//                             <Link to={"/product/" + product?._id} onClick={scrollTop}>
//                                 <div className='bg-gray-100 h-44 flex justify-center items-center overflow-hidden'>
//                                     <img
//                                         src={product?.productImage?.[0]}
//                                         alt={product?.productName}
//                                         className='h-full object-contain group-hover:scale-110 transition duration-500'
//                                     />
//                                 </div>
//                             </Link>

//                             <div className='p-4'>

//                                 {/* TITLE */}
//                                 <Link to={"/product/" + product?._id} onClick={scrollTop}>
//                                     <h2 className='font-semibold text-base line-clamp-1'>
//                                         {product?.productName}
//                                     </h2>
//                                 </Link>

//                                 {/* CATEGORY */}
//                                 <p className='text-sm text-gray-500 capitalize'>
//                                     {product?.category}
//                                 </p>

//                                 {/* PRICE */}
//                                 <div className='mt-2 flex gap-2 items-center'>
//                                     <p className='text-red-600 font-bold text-lg'>
//                                         {displayINRCurrency(price)}
//                                     </p>
//                                 </div>

//                                 {/* BUTTON */}
//                                 <button
//                                     className='mt-3 w-full bg-red-600 hover:bg-red-700 text-white py-2 rounded-lg transition opacity-0 group-hover:opacity-100'
//                                     onClick={(e) => handleAddToCart(e, product?._id)}
//                                 >
//                                     Add to Cart
//                                 </button>

//                             </div>

//                         </motion.div>
//                     )
//                 })
//             )}

//         </div>
//     )
// }

// export default VerticalCard
import React, { useContext } from "react";
import { motion } from "framer-motion";
import displayINRCurrency from "../helpers/displayCurrency";
import { FaShoppingCart, FaArrowRight } from "react-icons/fa";
import SummaryApi from "../common";
import Context from "../context";
import { useNavigate } from "react-router-dom";

const VerticalCard = ({ data }) => {

  const product = data[0];
  const navigate = useNavigate();
  const { fetchUserAddToCart } = useContext(Context);

  // ✅ VARIANT BASED PRICE
  const variant = product?.variants?.[0];
  const price = Number(variant?.price || 0);

  // ✅ ADD TO CART
  const handleAddToCart = async (e) => {
    e.stopPropagation(); // 🔥 VERY IMPORTANT

    const response = await fetch(SummaryApi.addToCartProduct.url, {
      method: SummaryApi.addToCartProduct.method,
      credentials: "include",
      headers: { "content-type": "application/json" },
      body: JSON.stringify({
        productId: product?._id,
        ram: variant?.ram,
        storage: variant?.storage,
        price: price
      }),
    });

    const resData = await response.json();

    if (resData.success) {
      fetchUserAddToCart();
      alert("Added to cart ✅");
    }
  };

  // ✅ BUY NOW → GO TO PRODUCT DETAILS
  const handleBuyNow = (e) => {
    e.stopPropagation(); // 🔥 IMPORTANT
    navigate(`/product/${product?._id}`);
  };

  return (
    <motion.div
      whileHover={{ y: -10 }}
      onClick={() => navigate(`/product/${product?._id}`)} // 🔥 CARD CLICK
      className="bg-white rounded-[30px] p-3 shadow-md hover:shadow-2xl transition-all duration-300 cursor-pointer"
    >

      {/* IMAGE */}
      <img
        src={product?.productImage?.[0]}
        className="w-full h-64 object-cover rounded-[20px]"
      />

      {/* DETAILS */}
      <div className="mt-4">

        <h2 className="font-bold text-lg line-clamp-1">
          {product?.productName}
        </h2>

        <p className="text-gray-500 text-sm">
          {product?.brand}
        </p>

        {/* PRICE + BUTTONS */}
        <div className="flex justify-between items-center mt-4">

          <div className="bg-gray-100 px-4 py-2 rounded-full font-semibold">
            {displayINRCurrency(price)}
          </div>

          <div className="flex gap-2">

            {/* ADD TO CART */}
            <button
              onClick={handleAddToCart}
              className="bg-black text-white p-3 rounded-full hover:bg-gray-800"
            >
              <FaShoppingCart />
            </button>

            {/* BUY NOW */}
            <button
              onClick={handleBuyNow}
              className="bg-black text-white px-4 py-2 rounded-full flex items-center gap-2 hover:bg-gray-800"
            >
              Buy <FaArrowRight className="text-xs" />
            </button>

          </div>

        </div>

      </div>

    </motion.div>
  );
};

export default VerticalCard;